module.exports = __webpack_public_path__ + "media/images/icons/vendors/churches-a16178816062ecb13397660ea20240b7.png";